import StatisticsRow from '../StatisticsRow';
import ShotsPerGameLabel from './ShotsPerGameLabel';
import TeamShotsJerseyColumn from './TeamShotsJerseyColumn';

interface RowTeamShotsPerGameProps {
  /** Additional CSS classes to apply to the row container. */
  className?: string;
  /** Optional CSS classes to apply to the number elements. */
  numberColumnClassName?: string;
  /** Home team shots-per-game value. */
  homeNumber: number;
  /** Away team shots-per-game value. */
  awayNumber: number;
  /** Home team jersey image URL (left). */
  homeJerseySrc: string;
  /** Away team jersey image URL (right). */
  awayJerseySrc: string;
}

export default function RowTeamShotsPerGame({
  className = '',
  homeNumber,
  awayNumber,
  homeJerseySrc,
  awayJerseySrc,
}: RowTeamShotsPerGameProps) {
  return (
    <StatisticsRow className={`gap-3 px-0 ${className ?? ''}`}>
      <TeamShotsJerseyColumn jerseySrc={homeJerseySrc} shotsPerGame={homeNumber} />
      <div className="relative flex min-h-px min-w-0 w-full flex-1 shrink items-center justify-center">
        <ShotsPerGameLabel />
      </div>
      <TeamShotsJerseyColumn jerseySrc={awayJerseySrc} isAway shotsPerGame={awayNumber} />
    </StatisticsRow>
  );
}
